import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";

/**
 * Search + dropdown filter bar with bulk approve/clear, shared by the MCQ conversion
 * and Similar Paper review pages.
 *
 * Props:
 *   search, onSearchChange, placeholder
 *   filters — [{ key, label, value, onChange, options: [{value,label}], minWidth }]
 *   visibleCount, totalCount
 *   onApproveShown, onClearShown, bulkDisabled
 */
const ReviewFilterBar = ({
  search,
  onSearchChange,
  placeholder,
  filters = [],
  visibleCount,
  totalCount,
  onApproveShown,
  onClearShown,
  bulkDisabled = false,
}) => (
  <Paper
    variant="outlined"
    sx={{ p: 1.5, mb: 2, display: "flex", gap: 1.5, alignItems: "center", flexWrap: "wrap" }}
  >
    <TextField
      size="small"
      placeholder={placeholder}
      value={search}
      onChange={(e) => onSearchChange(e.target.value)}
      sx={{ flex: "1 1 260px" }}
    />
    {filters.map((f) => (
      <FormControl key={f.key} size="small" sx={{ minWidth: f.minWidth || 150 }}>
        <InputLabel>{f.label}</InputLabel>
        <Select label={f.label} value={f.value} onChange={(e) => f.onChange(e.target.value)}>
          {f.options.map((o) => (
            <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
          ))}
        </Select>
      </FormControl>
    ))}
    <Box sx={{ flex: 1 }} />
    <Typography variant="caption" color="text.secondary">
      {visibleCount} of {totalCount}
    </Typography>
    {onApproveShown && (
      <Button size="small" onClick={onApproveShown} disabled={bulkDisabled}>
        Approve shown
      </Button>
    )}
    {onClearShown && (
      <Button size="small" onClick={onClearShown} disabled={bulkDisabled}>
        Clear shown
      </Button>
    )}
  </Paper>
);

export default ReviewFilterBar;
